import { render, staticRenderFns } from "./UnblockOrder.vue?vue&type=template&id=3c8040d4"
import script from "./UnblockOrder.js?vue&type=script&lang=js&external"
export * from "./UnblockOrder.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports